
interface FilesInterface {
  selectedJob: Job[];
}

import ModelMetadataFile from '@/models/modelMetadataFile';
import Job from '@/models/job';
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';
import { bus } from '@/main';
import { AxiosError, AxiosResponse } from 'axios';

const ModelPublishFiles = (Vue as VueConstructor<Vue & FilesInterface>).extend({
  props: {
    selectedJob: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      files: [] as ModelMetadataFile[],
      filesRetreived: false,
    };
  },

  mounted() {
    this.fetchFiles();
  },

  methods: {
    fetchFiles() {
      const job = this.selectedJob[0];
      this.$http
        .get<never>('modelmetadata?jobId=' + job.id)
        .then((result: AxiosResponse<ModelMetadataFile[]>) => {
          this.files = result.data;

          this.filesRetreived = true;
        })
        .catch((error: AxiosError) => {
          this.filesRetreived = true;
          bus.$emit('alert', 'Get files failed ', 'error', 6000, error, false);
        });
    },
  },
});

export default ModelPublishFiles;
